import ToolType from "@/wbcontroller/types/ToolType";

export interface ToolHUDItem {
  toolType: ToolType;
  icon: string;
  label: string;
  hotkey?: string;
  style?: string;
}

const allToolHUDItems: ToolHUDItem[] = [
  {
    toolType: ToolType.Select,
    icon: "/img/icons/select-outline.svg",
    label: "Select",
    hotkey: "v",
  },

  {
    toolType: ToolType.ImageUpload,
    icon: "/img/icons/image-outline.svg",
    label: "Image",
  },

  {
    toolType: ToolType.Pen,
    icon: "/img/icons/brush-outline.svg",
    label: "Pen",
    hotkey: "p",
  },

  {
    toolType: ToolType.Marker,
    icon: "/img/icons/water-outline.svg",
    label: "Marker",
    hotkey: "shift+p",
  },

  {
    toolType: ToolType.Eraser,
    icon: "/img/icons/eraser-outline.svg",
    label: "Eraser",
    hotkey: "e",
  },

  {
    toolType: ToolType.Sticky,
    icon: "/img/icons/stickynote-outline.svg",
    label: "Sticky note",
    hotkey: "s",
  },

  {
    toolType: ToolType.Text,
    icon: "/img/icons/text-outline.svg",
    label: "Text",
    hotkey: "t",
    style: "",
  },

  {
    toolType: ToolType.ImageLibrary,
    icon: "/img/icons/book-outline.svg",
    label: "Image Library",
    hotkey: "i",
    style: "",
  },

  {
    toolType: ToolType.Arrow,
    icon: "/img/icons/arrow-forward-outline.svg",
    label: "Arrow",
    hotkey: "|",
    style: "transform: rotate(-45deg) scale(0.85);",
  },

  {
    toolType: ToolType.Line,
    icon: "/img/icons/remove-outline.svg",
    label: "Line",
    hotkey: "\\",
    style: "transform: rotate(-45deg);",
  },

  {
    toolType: ToolType.Rect,
    icon: "/img/icons/square-outline.svg",
    label: "Rectangle",
    hotkey: "r",
  },

  {
    toolType: ToolType.Ellipse,
    icon: "/img/icons/ellipse-outline.svg",
    label: "Ellipse",
    hotkey: "l",
  },

  {
    toolType: ToolType.Diamond,
    icon: "/img/icons/square-outline.svg",
    label: "Diamond",
    hotkey: "d",
    style: "transform: rotate(45deg) scale(0.85);",
  },
];

export const toolTypeToUIData: Partial<Record<ToolType, ToolHUDItem>> = {};

for (const item of allToolHUDItems) {
  toolTypeToUIData[item.toolType] = item;
}

export const defaultToolTypes: ToolType[] = allToolHUDItems.map(
  (i) => i.toolType
);
